/**
 * Reproduce el sonido de notificación de la app.
 * El audio es "Positive Notification" de Mixkit (licencia Mixkit: uso libre,
 * comercial y no comercial, sin atribución).
 */
import notificationSound from '../assets/sounds/notification.mp3';

let audioInstance: HTMLAudioElement | null = null;
let unlockArmed = false;

// Los navegadores bloquean play() hasta la primera interacción del usuario
// (sticky activation, por carga de página). Con entrega por socket la
// notificación puede llegar antes de esa primera interacción: al detectar el
// bloqueo, desbloqueamos el elemento en cuanto el usuario toque la página.
const armUnlockOnFirstGesture = () => {
  if (unlockArmed || !audioInstance) {
    return;
  }
  unlockArmed = true;
  const unlock = () => {
    unlockArmed = false;
    const instance = audioInstance;
    if (!instance) {
      return;
    }
    instance
      .play()
      .then(() => {
        // Play + pause inmediato solo habilita el audio del elemento: no se
        // escucha nada ahora, pero los próximos play() programáticos sí.
        instance.pause();
        instance.currentTime = 0;
      })
      .catch(() => {
        // Aún bloqueado (ej. iOS exige el gesto directo); reintentar en la
        // próxima interacción.
        armUnlockOnFirstGesture();
      });
  };
  document.addEventListener('pointerdown', unlock, { once: true });
};

export const playNotificationSound = () => {
  try {
    if (!audioInstance) {
      audioInstance = new Audio(notificationSound);
      audioInstance.preload = 'auto';
    }
    // Reiniciar por si hay solapamiento de notificaciones
    audioInstance.currentTime = 0;
    audioInstance.play().catch((err: any) => {
      console.warn(
        `No se pudo reproducir el sonido de notificación (${err?.name}: ${err?.message})`
      );
      if (err?.name === 'NotAllowedError') {
        armUnlockOnFirstGesture();
      } else if (err?.name === 'NotSupportedError') {
        // El elemento pudo quedar en mal estado (ej. tras reemplazar el
        // archivo): descartarlo para que la próxima notificación use uno
        // recién creado con el recurso actual.
        audioInstance = null;
      }
    });
  } catch (error) {
    console.error('Error reproduciendo sonido de notificación:', error);
  }
};
